import { apiTranslations } from '../../../translations';

import { IDeviceImageOptions } from '../../types';

import { DeviceImageUploadWithFile } from './DeviceImageUploadWithFile';
import { DeviceImagePromptItem } from './DeviceImagePromptItem';

interface IDeviceImageItemProps extends IDeviceImageOptions {
  // Add more props here if required.
}

/**
 * -----------------------------------------------------------------------------
 * Creates functionality either for selecting & uploading an image with
 * `DeviceImagePromptItem` or previewing the uploaded images with
 * `DeviceImageUploadWithFile`.
 */
export function DeviceImageItem({
  onUpdateImage,
  imageData,
}: IDeviceImageItemProps) {
  const { color, position } = imageData.metadata;

  const title = apiTranslations.positions[position];
  const titlePostfix = apiTranslations.colors[color];

  const subTitle = apiTranslations.positionsDescription[position];
  const subTitleDescription = apiTranslations.colorsDescription[color];

  if (imageData.croppedImgSrc) {
    return (
      <DeviceImageUploadWithFile
        // subTitle={subTitle}
        imageData={imageData}
        title={title}
        titlePostfix={titlePostfix}
      />
    );
  }

  return (
    <DeviceImagePromptItem
      imageData={imageData}
      onUpdateImage={onUpdateImage}
      subTitle={subTitle}
      subTitleDescription={subTitleDescription}
      title={title}
      titlePostfix={titlePostfix}
    />
  );
}
